import React, { useContext } from 'react'

import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'

import { AskDoctorContext } from '../context'
import { Section } from '../Section'
import { StyledCreateNewPostContentV2 } from '../Section/index.styled'
import { StyledWrapper } from './index.styled'

export type Props = {
  editPost?: boolean
  onPostCreatedEdited?: any
}

const PostForm = ({ onPostCreatedEdited, ...rest }: Props) => {
  const { formatMessage: f } = useIntl()
  const {
    article,
    setShowPostForm,
    editPostData,
    handleClosePopup,
    setEditPostData,
  } = useContext(AskDoctorContext)
  const {
    state: { userInfo },
  } = useContext(AppContext)
  const editPost = !editPostData
  const articleId = article?.id

  const sortedCategories = article?.breadcrumb || []

  return (
    <Section
      style={{ zIndex: 10 }}
      styleBody={{ padding: '0px' }}
      heading={
        editPost
          ? f({
              id: 'commentPopup.title.updatePost',
              defaultMessage: 'Update post',
            })
          : f({
              id: 'askDoctor.postForm.heading',
              defaultMessage: 'Tạo câu hỏi',
            })
      }
      handleBackFn={() => setShowPostForm(false)}
      handleCloseFn={handleClosePopup}
      popupConfirmBackProps={{
        thumbnail: '/svg/icon-cancel.svg',
        // isThumbnailIcon: true,
        title: f({
          id: 'commentPopup.createPost.confirmCloseTitle',
          defaultMessage: 'Are you sure?',
        }),
        description: f({
          id: 'commentPopup.createPost.confirmCloseDescription',
          defaultMessage: 'If you discard now, you’ll lose this post',
        }),
        acceptText: f({
          id: editPost
            ? 'commentPopup.discardPostEdit'
            : 'commentPopup.discardPost',
          defaultMessage: editPost ? 'Discard changes' : 'Discard post',
        }),
        cancelText: f({
          id: 'commentPopup.keepEditing',
          defaultMessage: 'Keep editing',
        }),
        onAccept: async () => {
          setShowPostForm(false)
          setEditPostData()
        },
      }}
      popupConfirmCloseProps={{
        thumbnail: '/svg/icon-cancel.svg',
        // isThumbnailIcon: true,
        title: f({
          id: 'commentPopup.createPost.confirmCloseTitle',
          defaultMessage: 'Are you sure?',
        }),
        description: f({
          id: 'commentPopup.createPost.confirmCloseDescription',
          defaultMessage: 'If you discard now, you’ll lose this post',
        }),
        acceptText: f({
          id: editPost
            ? 'commentPopup.discardPostEdit'
            : 'commentPopup.discardPost',
          defaultMessage: editPost ? 'Discard changes' : 'Discard post',
        }),
        cancelText: f({
          id: 'commentPopup.keepEditing',
          defaultMessage: 'Keep editing',
        }),
        onAccept: async () => {
          handleClosePopup(false)
          setEditPostData()
        },
      }}
      {...rest}
    >
      <StyledWrapper>
        <StyledCreateNewPostContentV2
          style={{ padding: 0 }}
          onPostCreatedEdited={onPostCreatedEdited}
          forceSelectCommunity={{
            name: sortedCategories[0].name,
            mappedCategoryId: Number(sortedCategories[0].termId),
          }}
          forceSelectTopics={sortedCategories.slice(1).map((c: any) => ({
            name: c.name,
            mappedCategoryId: Number(c.termId),
          }))}
          articleId={String(articleId)}
          isMarryBaby={true}
          // onClose={() => {
          // if (openPostOnCloseRef.current?.id) {
          //   setCommentPopupState('comment-detail')
          //   setPostDetail(openPostOnCloseRef.current)
          // } else {
          //   setCommentPopupState('comment-list')
          // }
          // openPostOnCloseRef.current = undefined
          // }}
          optionalTopic
          editPostData={editPostData}
          noFetchTopic
          // onPostCreatedEdited={(p) => (openPostOnCloseRef.current = p)}
          hideTopicList
          showAskDoctorOptions={true}
          selectAskDoctor={true}
          userInfo={userInfo}
        />
      </StyledWrapper>
    </Section>
  )
}

export { PostForm }
